import React from 'react';

import { Typography } from 'components/alf-design';

const BlockedAccountAlert = () => {
  return (
    <div className="bg-legacy-errorBackground m-[24px] p-[10px] rounded-[8px]">
      <Typography type="error" style={{ textAlign: 'center' }}>
        Your account has been blocked. If you haven't received an email to
        unblock, please contact support.
      </Typography>
    </div>
  );
};

export default BlockedAccountAlert;
